import { AvatarItemDto, GetAvatarsResponseDto } from './avatar.dto';
import { AvatarData, AvatarItem } from './avatar.entity';

export class AvatarMapper {
  static toItemEntity(dto: AvatarItemDto): AvatarItem {
    return {
      id: dto.id,
      name: dto.name,
      atlasReference: dto.atlasReference,
      atlasHashedReference: dto.atlasHashedReference,
      index: dto.index,
      requirementType: dto.requirementType,
      requiredAmount: dto.requiredAmount,
      urlPath: dto.urlPath,
    };
  }

  static toDataEntity(dto: GetAvatarsResponseDto): AvatarData {
    return {
      atlases: dto.atlases,
      icons: dto.icons.map(this.toItemEntity),
      avatars: dto.avatars.map(this.toItemEntity),
    };
  }
}
